var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import './SelectRestaurant.scss';
import Select, { components } from 'react-select';
import Loader from '@/components/Loader/Loader';
var SelectRestaurant = function (_a) {
    var restaurant = _a.restaurant, setRestaurant = _a.setRestaurant, isLoading = _a.isLoading, selectedId = _a.selectedId;
    var BodyTextOne = useCallback(function (_a) {
        var title = _a.title, size = _a.size;
        return (_jsx("div", __assign({ style: size ? { fontSize: size } : {}, className: "BodyTextOne" }, { children: title })));
    }, []);
    var options = restaurant.map(function (item) { return ({ value: item.id, label: _jsx(BodyTextOne, { title: item.name }), searchLabel: item.name, restaurant: item }); });
    var _b = useState(), selectedOption = _b[0], setSelectedOption = _b[1];
    useEffect(function () {
        var selected = options.find(function (item) { return item.value === selectedId; });
        setSelectedOption(selected);
    }, [selectedId]);
    var CustomInput = useCallback(function (props) {
        return _jsx(components.Input, __assign({}, props));
    }, []);
    var handleChange = function (selected) {
        setRestaurant(selected.restaurant);
    };
    if (isLoading)
        return _jsx("div", __assign({ style: { marginBottom: '20px' } }, { children: _jsx(Loader, { width: '24px', height: '24px' }) }));
    if (restaurant.length === 0) {
        return _jsx("div", __assign({ className: "empty-list" }, { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" }));
    }
    return (_jsx(Select, { components: { Input: CustomInput }, value: selectedOption || options[0], defaultValue: selectedOption, isSearchable: true, getOptionLabel: function (e) { return e.searchLabel; }, filterOption: function (option, inputValue) {
            return option.data.searchLabel.toLowerCase().includes(inputValue.toLowerCase());
        }, className: "SelectRestaurant", onChange: handleChange, options: options, isDisabled: restaurant.length === 0, styles: {
            control: function (baseStyles, state) {
                return (__assign(__assign({}, baseStyles), { background: 'none', cursor: 'pointer', fontSize: '20px', backgroundColor: 'white', fontWeight: 700, color: '#000000', border: 'none', boxShadow: state.isFocused ? 'none' : 'none', '&:hover': {
                        borderColor: '#EFF0F4',
                        border: '0px solid',
                    } }));
            },
            option: function (base) {
                return (__assign(__assign({}, base), { color: '#000000', background: '#fff', '&:hover': {
                        backgroundColor: '#F7F8FC',
                    }, paddingLeft: '16px', paddingRight: '0px', marginLeft: '0px', marginRight: '0px' }));
            },
            group: function (base) { return (__assign(__assign({}, base), { paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '0px' })); },
            menuList: function (base) { return (__assign(__assign({}, base), { boxShadow: 'none', color: 'white', borderWidth: '0px', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '0px' })); },
            menu: function (provided) { return (__assign(__assign({}, provided), { borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '0px' })); },
            dropdownIndicator: function (base, state) { return (__assign(__assign({}, base), { color: '#000000', transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease', paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '20px' })); },
            indicatorSeparator: function (base) { return (__assign(__assign({}, base), { display: 'none' })); },
        } }));
};
export default SelectRestaurant;
